import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryOrderDetail extends BaseModelAPI {
	static entity = 'deliveryorderdetail';
	static entityName = 'deliveryorderdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.deliveryOrderId = '';
			this.deliveryOrder = {};
			this.poNumber = '';
			this.partId = '';
			this.part = {};
			this.qtyPerUnit = 0;
			this.deliveryDate = '';
			this.poDetailId = '';
			this.poDetail = {};
			this.deliveryStatusId = '';
			this.deliveryStatus = {};
			this.doProgressStatusId = '';
			this.doProgressStatus = {};
			this.partDestinationId = '';
			this.partDestination = {};
			this.destinationId = '';
			this.destination = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}